import { RequestService } from '../../../../common/services/RequestService';
import { GET_EXECUTOR_BY_ID } from '../constants'; // , GET_EXECUTOR_BY_ID
import { adjustExecutor } from './adjustExecutorById';

export const getExecutorByIdRequest = async (profileId, executorId) => {
  const response = await RequestService.get(
    GET_EXECUTOR_BY_ID.replace('{company_exec_id}', executorId).replace(
      '{profile_id}',
      profileId
    )
  );
  return response.data && adjustExecutor(response.data);
};
